import { render } from "./detail.vue?vue&type=template&id=5148ccb1&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"

import "./detail.vue?vue&type=style&index=0&id=5148ccb1&scoped=true&lang=css"

import exportComponent from "/home/wido/Documents/Project/SS-GreedGreed/ss-web-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5148ccb1"]])

export default __exports__